import byteliveApi from './api/byteliveApi';
import { objectToQueryString } from '../utils';

const initialState = {
};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const liveprogramList = (payload) => {
  return dispatch => {
    const queryString = objectToQueryString(payload);
    return byteliveApi.get(`/liveprogram${queryString}`).then(data => {
      let result = {...data};
      result.results = result.results
        .map(res => {return {...res}})
        .sort((a, b) => {
            if (a.isLive && !b.isLive) return -1;
            if (!a.isLive && b.isLive) return 1;
            return 0;
          });
      return result;
    }).catch(error => {
      throw (error);
    });
  };  
}